export const environment = {
  endpoint: 'https://api-stg.sanantonio.digital/api/',
  production: false,
  storage: 'san_antonio_admin_angular',
  dashboard: '/admin/submissions',
  title: 'Sanantonio Admin',
  googleApi: 'AIzaSyBM9e9__TVACstA4Be9DVzSsX89l9jrKPk',
};
